/**
 * processos.ts — hub Processo Licitatório (F5).
 */

import type { components } from './generated/api'
import { api } from './http'

export type ProcessoLicitatorio = components['schemas']['ProcessoLicitatorio']
export type Acao = components['schemas']['Acao']

export function listarProcessosLicitatorios() {
  return api<ProcessoLicitatorio[]>('/api/v1/processos-licitatorios')
}

export function excluirProcessoLicitatorio(id: number) {
  return api<null>(`/api/v1/processos-licitatorios/${id}`, { method: 'DELETE' })
}
